import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconCaretUp = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M18.707 14.793a1 1 0 0 1-1.414 0L12 9.5l-5.293 5.293a1 1 0 0 1-1.414-1.414l5.293-5.293a2 2 0 0 1 2.828 0l5.293 5.293a1 1 0 0 1 0 1.414", clipRule: "evenodd" }) });
const ForwardRef = forwardRef(SvgIconCaretUp);
export default ForwardRef;
